import { options } from './Options'

const NBRProductStatus = ['application', 'in-force', 'withdrawnsurrender', 'lapsed', 'freelook', 'nottaken', '', 'open', 'closed'] as const

export type IssuerProductStatus = typeof NBRProductStatus[number]
interface ProductStatus extends options{
  value: IssuerProductStatus;
  label: string;
}
export const NBRProductStatusOptions: ProductStatus[] = [
  { value: 'application', label: 'Application' },
  { value: 'in-force', label: 'In-force' },
  { value: 'withdrawnsurrender', label: 'Withdrawn / Surrender' },
  { value: 'lapsed', label: 'Lapsed' },
  { value: 'freelook', label: 'Free look' },
  { value: 'nottaken', label: 'Not taken' }
]

export const NBRProductCISStatusOptions: options[] = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' }
]
